import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="bg-navy text-white py-6">
      <div className="max-w-[1180px] mx-auto px-4">
        {/* Social links */}
        <div className="flex justify-center gap-3 mb-3">
          <a
            href="https://www.facebook.com/basehitgame"
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-white/60 hover:text-white transition-colors"
            aria-label="BaseHit on Facebook"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          </a>
          <a
            href="https://discord.gg/RwjTgJ93eU"
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-white/60 hover:text-white transition-colors"
            aria-label="BaseHit on Discord"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.947 2.418-2.157 2.418z" />
            </svg>
          </a>
          <a
            href="https://www.youtube.com/@basehitgame"
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-white/60 hover:text-white transition-colors"
            aria-label="BaseHit on YouTube"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
          </a>
        </div>

        {/* Site links — separated by middot for a clean inline list. */}
        <div className="flex justify-center items-center gap-x-3 gap-y-1 flex-wrap text-xs">
          <Link to="/privacy" className="text-white/60 hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <span className="text-white/40">·</span>
          <Link to="/supportus" className="text-white/60 hover:text-white transition-colors">
            Support BaseHit
          </Link>
          <span className="text-white/40">·</span>
          <Link to="/user/referral" className="text-white/60 hover:text-white transition-colors">
            Refer a Friend
          </Link>
          <span className="text-white/40">·</span>
          <a href="mailto:support@basehit.com" className="text-white/60 hover:text-white transition-colors">
            Contact Us
          </a>
          <span className="text-white/40">·</span>
          <Link to="/" className="text-white/60 hover:text-white transition-colors">
            &copy; BaseHit
          </Link>
        </div>

        {/* Site identity for visitors and crawlers: BaseHit is a sports simulation,
            not a real-money product — keep this in sync with landing.html's footer. */}
        <p className="mt-3 text-center text-[11px] leading-relaxed text-white/40">
          BaseHit is a free online baseball management simulation. All players are
          fictional, and no real money is wagered, staked, or won as part of the game
          itself.
        </p>
      </div>
    </footer>
  )
}
